import { GTMEventAuth } from '@/fo/api/gtm';

let authRedirectUrl: string | undefined;

export const EVENT_OPEN_AUTH_MODAL = 'open-auth-modal';
export const EVENT_CLOSE_AUTH_MODAL = 'close-auth-modal';
export const EVENT_SHOW_FORGOT_PASSWORD = 'show-forgot-password';
export const EVENT_SHOW_LOGIN = 'show-login';

export const utilEventAuthModal = {
  open: (referral: GTMEventAuth['referral'], redirectUrl?: string) => {
    authRedirectUrl = redirectUrl;
    window.dispatchEvent(
      new CustomEvent(EVENT_OPEN_AUTH_MODAL, {
        detail: { referral, redirectUrl }
      })
    );
  },

  close: () => {
    window.dispatchEvent(new CustomEvent(EVENT_CLOSE_AUTH_MODAL));
    authRedirectUrl = undefined;
  },

  showForgotPassword: () => {
    window.dispatchEvent(new CustomEvent(EVENT_SHOW_FORGOT_PASSWORD));
  },

  showLogin: (email?: string) => {
    window.dispatchEvent(
      new CustomEvent(EVENT_SHOW_LOGIN, { detail: { email } })
    );
  },

  onOpen: (
    callback: (referral: GTMEventAuth['referral'], redirectUrl?: string) => void
  ) => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent).detail as {
        referral: GTMEventAuth['referral'];
        redirectUrl?: string;
      };
      callback(detail.referral, detail.redirectUrl);
    };
    window.addEventListener(EVENT_OPEN_AUTH_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_OPEN_AUTH_MODAL, handler);
    };
  },

  onClose: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_CLOSE_AUTH_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_CLOSE_AUTH_MODAL, handler);
    };
  },

  onShowForgotPassword: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_SHOW_FORGOT_PASSWORD, handler);

    return () => {
      window.removeEventListener(EVENT_SHOW_FORGOT_PASSWORD, handler);
    };
  },

  onShowLogin: (callback: (email?: string) => void) => {
    const handler = (event: Event) =>
      callback((event as CustomEvent).detail.email);
    window.addEventListener(EVENT_SHOW_LOGIN, handler);

    return () => {
      window.removeEventListener(EVENT_SHOW_LOGIN, handler);
    };
  },
  getRedirectUrl: () => authRedirectUrl
};
